export var DEFAULT_AUTHOR_DISPLAY_CLASSNAME = 'author';